import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { components } from 'react-select';
export const Input = props => {
  return _jsx(components.Input, {
    ...props,
    "aria-describedby": props.selectProps.message ? `${props.id}-message` : undefined,
    "aria-invalid": !!props.selectProps.invalid
  });
};